module.exports = __webpack_public_path__ + "images/emoji/rotating_light.4201923459358c7e3781.png";